import styles from "../../../../MapMonitoring/components/AddMarkerModal/AddIncidentModal.module.css";
import React, { useEffect, useMemo, useReducer } from "react";
import { TextField } from "@mui/material";
import useAppSnackbar from "../../../../../hooks/useAppSnackbar";
import { groupGeofenceService } from "../../../../../services/guide/groupGeofence-service";
import { useFetchGetGroupGeofenceById } from "../../../../../hooks/guide/useFetchGetGroupGeofenceById";
import {
    CreateGroupGeofence,
    UpdateGroupGeofence,
} from "../../../../../types/api/guide/groupGeofence.types";

type FormState = {
    name: string;
};

type Action =
    | { type: "SET_FIELD"; name: keyof FormState; value: any }
    | { type: "SET_All"; payload: FormState }
    | { type: "RESET" };

const initialState: FormState = {
    name: "",
};

const reducer = (state: FormState, action: Action): FormState => {
    switch (action.type) {
        case "SET_FIELD":
            return { ...state, [action.name]: action.value };

        case "SET_All":
            return { ...action.payload };

        case "RESET":
            return initialState;

        default:
            return state;
    }
};

interface GroupGeofenceAddModalProps {
    onClose: () => void;
    refetchData: () => void;
    id: string;
}

export const GroupGeofenceAddModal = ({ onClose, refetchData, id }: GroupGeofenceAddModalProps) => {
    const { showSuccess, showError, SnackbarComponent } = useAppSnackbar();

    const { data: group } = useFetchGetGroupGeofenceById(id);

    const [state, dispatch] = useReducer(reducer, initialState);

    useEffect(() => {
        if (!group) return;
        dispatch({
            type: "SET_All",
            payload: {
                name: group.name,
            },
        });
    }, [group]);

    const handleValue = (event: any) => {
        const { name, value } = event.target;
        dispatch({ type: "SET_FIELD", name, value });
    };

    const canSave = useMemo(() => {
        if (!state.name.trim()) return false;
        return true;
    }, [state]);

    const handleSave = async () => {
        try {
            if (!group) {
                const payload: CreateGroupGeofence = {
                    name: state.name.trim(),
                };

                await groupGeofenceService.create(payload);
                showSuccess("Группа геозон создана");
            } else {
                const payload: UpdateGroupGeofence = {
                    id: group.id,
                    name: state.name.trim(),
                };

                await groupGeofenceService.update(group.id, payload);
                showSuccess("Группа геозон обновлена");
            }

            refetchData();
            onClose();
            dispatch({ type: "RESET" });
        } catch (e: any) {
            showError(e?.response?.data ?? "Ошибка при обновлении/добавлении группы геозон");
        }
    };

    return (
        <div className={styles.modalOverlay}>
            <div className={styles.modal}>
                <div className={styles.modalHeader}>
                    <h3 className={styles.modalTitle}>
                        {group ? "Редактировать группу геозон" : "Добавить группу геозон"}
                    </h3>
                    <button className={styles.modalClose} onClick={onClose}>
                        ×
                    </button>
                </div>

                <div className={styles.modalBody}>
                    <div className={styles.modalField}>
                        <div className={styles.modalLabel}>Название</div>
                        <div className={styles.modalCoords}>
                            <TextField
                                name="name"
                                value={state.name}
                                onChange={handleValue}
                                fullWidth
                            />
                        </div>
                    </div>
                </div>

                <div className={styles.modalFooter}>
                    <button className={styles.modalButton} onClick={onClose}>
                        Отмена
                    </button>

                    <button
                        className={`${styles.modalButton} ${styles.modalButtonPrimary}`}
                        onClick={handleSave}
                        disabled={!canSave}
                        style={{ opacity: canSave ? 1 : 0.6 }}
                    >
                        Сохранить
                    </button>
                </div>
            </div>

            <SnackbarComponent />
        </div>
    );
};
